(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-reviews-carousel"] && !Shopify.designMode) return;
  try {
     
      document.addEventListener('DOMContentLoaded', function () {
        var swiper = new Swiper('.rev-container', {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
            // freeMode: true,
            // freeModeMomentum: false,
          speed: 2500,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            640: { slidesPerView: 2, spaceBetween: 10 },
            768: { slidesPerView: 3, spaceBetween: 10 },
            1024: { slidesPerView: 4, spaceBetween: 20 },
            1224: { slidesPerView: 4, spaceBetween: 20 },
            1540: { slidesPerView: 5, spaceBetween: 20 } // Add this breakpoint for larger screens
          },
          // autoplay: {
          //     delay: 4500,  // Time in ms before next slide
          //     disableOnInteraction: false,  // Continue autoplay after user interaction
          // },
        });
      });

      // document.addEventListener('DOMContentLoaded', function () {
      //   document.querySelectorAll('.vid-slide').forEach(function (element) {
      //     var href = element.querySelector('a').getAttribute('href');
      //     $(element).magnificPopup({
      //       items: {
      //         src: href
      //       },
      //       type: 'iframe'
      //     });
      //   });
      // });

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-video-feature"] && !Shopify.designMode) return;
  try {
    
   
   $(document).ready(function () {

	$(".show-vid").on("click", function () {
		var srcid = $(this).data("id");
		var $videoHold = $(".video-hold");
		var $loader = $(".loader");

		// Show loader
		$loader.show();

		// Remove the image
		var $img = $videoHold.find("img").detach();

		// Create the iframe
		var iframe = $("<iframe>", {
			src: "https://player.vimeo.com/video/" + srcid + "?autoplay=1",
			id: "video-frame",
			frameborder: 0,
			allow: "autoplay; fullscreen",
			allowfullscreen: true
		});

		// Add the iframe to the video-hold div
		$videoHold.append(iframe);

		// Hide loader once the iframe is loaded
		iframe.on("load", function () {
			$loader.hide();
		});

		// Setup Vimeo Player API to detect when the video ends
		var player = new Vimeo.Player(iframe[0]);
		player.on("ended", function () {
			// Remove the iframe
			iframe.remove();

			// Add the image back
			$videoHold.append($img);
		});
	});
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-videos-section"] && !Shopify.designMode) return;
  try {
    
   
   $(document).ready(function () {

	$(".show-vid").on("click", function () {
		var srcid = $(this).data("id");
		var $videoHold = $(".video-hold");
		var $loader = $(".loader");

		// Show loader
		$loader.show();

		// Remove the image
		var $img = $videoHold.find("img").detach();

		// Create the iframe
		var iframe = $("<iframe>", {
			src: "https://player.vimeo.com/video/" + srcid + "?autoplay=1",
			id: "video-frame",
			frameborder: 0,
			allow: "autoplay; fullscreen",
			allowfullscreen: true
		});

		// Add the iframe to the video-hold div
		$videoHold.append(iframe);

		// Hide loader once the iframe is loaded
		iframe.on("load", function () {
			$loader.hide();
		});

		// Setup Vimeo Player API to detect when the video ends
		var player = new Vimeo.Player(iframe[0]);
		player.on("ended", function () {
			// Remove the iframe
			iframe.remove();

			// Add the image back
			$videoHold.append($img);
		});
	});
});




  } catch(e) { console.error(e); }
})();
})();
